import React, { useState } from 'react';
import useSWR from 'swr';
import {
  Modal,
  Button,
  Table,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getScan } from '../../../services/carotidas';
import api from '../../../services/api';

const PROCEDIMENTOS_CAROTIDA = [14, 15];

const fetchLaudosCarotida = async ([, paciente]) => {
  const { data } = await api.get(`pacientes/${paciente}/atividades`);
  if (!Array.isArray(data)) {
    throw new Error('resposta inválida');
  }

  return data.filter(item => PROCEDIMENTOS_CAROTIDA.includes(item.CODPROCEDI));
};

export default function ModalCarotida({ show, onHide, codPac, onCopy }) {
  const [copyingId, setCopyingId] = useState(null);
  const { data, isLoading } = useSWR(
    show && codPac ? ['carotida-anteriores', codPac] : null,
    fetchLaudosCarotida,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      onError: () => toast.error('Erro ao buscar laudos anteriores.'),
    }
  );
  const laudos = data ?? [];

  const handleCopy = async laudo => {
    if (copyingId) return;

    try {
      setCopyingId(laudo.CODLAUDO);
      const data = await getScan(laudo.CODLAUDO);
      onCopy(data);
      onHide();
    } catch {
      toast.error('Erro ao copiar laudo.');
    } finally {
      setCopyingId(null);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        if (copyingId === null) onHide();
      }}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Selecionar Laudo Anterior</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : laudos.length === 0 ? (
          <p className="text-center text-muted">Nenhum laudo encontrado.</p>
        ) : (
          <Table
            size="sm"
            style={{ marginTop: 10, background: '#f8f9fa' }}
            striped
            hover
            bordered
            responsive
          >
            <thead>
              <tr>
                <th style={{ width: '110px', textAlign: 'center' }}>Data</th>
                <th style={{ width: '120px', textAlign: 'center' }}>Código</th>
                <th>Procedimento</th>
                <th style={{ width: '180px', textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {laudos.map(laudo => (
                <tr key={laudo.CODLAUDO}>
                  <td style={{ textAlign: 'center' }}>{laudo.dataFormatada}</td>
                  <td style={{ textAlign: 'center' }}>{laudo.CODLAUDO}</td>
                  <td>{laudo.DESCPROCEDI}</td>
                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-laudo-${laudo.CODLAUDO}`}>
                          Copiar todos os dados do laudo
                        </Tooltip>
                      }
                    >
                      <span>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          disabled={copyingId !== null}
                          onClick={() => handleCopy(laudo)}
                        >
                          <FaRegCopy style={{ marginRight: 4 }} />
                          Copiar Laudo
                        </Button>
                      </span>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={copyingId !== null}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
